export default {
  excelTableHeader: "F1F5F7",
  excelDetailTableHeader: "FEF2D1",
  excelDetailDetailTableHeader: "FBCCD2",
  pdfTableHeader: "#F1F5F7",
  pdfDetailTableHeader: "#FEF2D1",
  pdfDetailDetailTableHeader: "#FBCCD2",
}
